import { PowerIcon } from '@heroicons/react/24/outline';

import { StatsBox } from '@/modules/documents/view/components/pages/site-overview/stats-box';

export type CardTrippedSystemProps = {
  className?: string;
};

export function CardTrippedSystem({ className }: CardTrippedSystemProps) {
  return (
    <>
      <StatsBox
        className={className}
        icon={{
          color: 'green',
          element: <PowerIcon />,
        }}
        title="Inverters (Online / Offline)"
        value="93 / 0"
      >
        <StatsBox.Action />
      </StatsBox>
    </>
  );
}
